export default __webpack_public_path__ + "static/media/concise-logo-white.f34f4134.svg";